import { h } from 'preact';
import style from './style.less';
import cx from 'classnames';
import LinkEvent, { linkEventLabel } from '../../../linkevent';
import { Icon } from '@cube/blocks';

function BaseLinkEvent({ item, onLinkItemClick, theme, ...props }) {
	return (
		<LinkEvent link={item} {...props} onAfterClick={onLinkItemClick}>
			{ item.image && <img src={item.image[theme] || item.image.default || item.image} class={style.linkRendererImage} /> }
			{(!item.image && item.iconName) && <Icon name={item.iconName} class={style.linkRendererIcon} />}
			{!item.image && linkEventLabel(item, { class: style.linkRendererNavskinLabel })}
		</LinkEvent>
	);
}

function linkEventNavRendererTopLevel(theme) {
	return ({ isCurrent, ...props }) => ( //eslint-disable-line react/display-name
		<div class={cx(style.linkItemChrome, isCurrent && style.current)}>
			<BaseLinkEvent {...props} theme={theme} />
			<div class={style.highlight} />
		</div>
	);
}

function linkEventNavRenderer(theme) {
	return props => <BaseLinkEvent {...props} theme={theme} />; //eslint-disable-line react/display-name
}

export function navSkinRounded(theme) {
	return [
		{
			nav: cx(style.navigation, style[theme]),
			item: style.navItem,
			link: style.linkItem,
			linkRenderer: linkEventNavRendererTopLevel(theme),
			menu: style.menuItem,
			current: style.current
		},
		{
			item: style.subnavItem,
			linkRenderer: linkEventNavRenderer(theme),
			menu: style.subnavMenuItem,
			nav: style.subnav,
			chrome: style.firstTierSubnavChrome,
			openLeft: style.openLeft,
			current: style.current
		},
		{
			item: style.subnavItem,
			linkRenderer: linkEventNavRenderer(theme),
			menu: style.subnavMenuItem,
			nav: style.subnav,
			current: style.current,
			cascade: true
		}
	];
}

export function navSkinPlain(theme) {
	return [
		{
			nav: cx(style.navigation, style[theme]),
			linkRenderer: linkEventNavRenderer(theme),
			item: style.navItem,
			link: style.linkItem,
			menu: style.menuItem,
			current: style.current
		}
	];
}

export function topHatNavSkinRounded(theme, align) {
	return [
		{
			nav: cx(style.tophat, style[theme], style[align]),
			item: style.navItem,
			link: style.linkItem,
			linkRenderer: linkEventNavRenderer(theme),
			menu: style.menuItem,
			current: style.current
		},
		{
			item: style.subnavItem,
			linkRenderer: linkEventNavRenderer(theme),
			menu: style.subnavMenuItem,
			nav: style.subnav,
			chrome: style.firstTierSubnavChrome,
			openLeft: style.openLeft,
			current: style.current
		},
		{
			item: style.subnavItem,
			linkRenderer: linkEventNavRenderer(theme),
			menu: style.subnavMenuItem,
			nav: style.subnav,
			current: style.current,
			cascade: true
		}
	];
}
